import React from "react";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { Activity, Eye, AlertOctagon, FileBarChart2, LifeBuoy, ShieldCheck, Clock, Zap, Globe2, FileText } from "lucide-react";

const SERVICES = [
  { icon: Activity, title: "EDR / XDR Monitoring", desc: "Continuous detection across endpoints, identities, workloads and cloud telemetry." },
  { icon: Eye, title: "Endpoint Monitoring", desc: "Behavioural analytics, drift detection and auto-isolation for compromised hosts." },
  { icon: AlertOctagon, title: "Threat Detection", desc: "Curated detections mapped to MITRE ATT&CK with intelligent triage." },
  { icon: FileBarChart2, title: "Security Reporting", desc: "Executive dashboards and board-ready monthly posture reports." },
  { icon: LifeBuoy, title: "Incident Support", desc: "On-demand IR with playbooked containment, eradication and lessons learned." },
  { icon: ShieldCheck, title: "Managed Endpoint Protection", desc: "We run your EDR — tuning, response and 24/7 alert triage." },
];

const FEATURES = [
  { icon: Clock, title: "24/7 Operations", desc: "Always-on coverage with follow-the-sun handoff." },
  { icon: Zap, title: "Real-time Monitoring", desc: "Streaming detection with low-latency alerting." },
  { icon: Globe2, title: "Threat Intelligence", desc: "Curated feeds + frontline India-specific intel." },
  { icon: FileText, title: "Enterprise Reporting", desc: "Compliance-ready evidence and audit trails." },
];

export default function MSSP() {
  return (
    <div data-testid="mssp-page">
      <PageHero
        eyebrow="Managed Security · MSSP"
        title="Managed Security Services for Modern Enterprises"
        description="Outsource the noise, keep the control. Our SOC operates as an extension of your team — detecting, responding and reporting around the clock."
      />

      <section className="py-20 bg-white">
        <div className="container-cd">
          <SectionHeading eyebrow="Services" title="What's included" />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => (
              <div key={s.title} className="card-cd" data-testid={`mssp-service-${i}`}>
                <span className="h-11 w-11 grid place-items-center rounded-xl bg-blue-50 border border-blue-100">
                  <s.icon size={20} className="text-[#3B82F6]" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-[#0A1B5E]">{s.title}</h3>
                <p className="mt-2 text-slate-600 text-[15px] leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAFC]">
        <div className="container-cd">
          <SectionHeading eyebrow="Features" title="Built for enterprise scale" />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {FEATURES.map((f, i) => (
              <div key={f.title} className="card-cd" data-testid={`mssp-feature-${i}`}>
                <span className="h-11 w-11 grid place-items-center rounded-xl gradient-cta text-white">
                  <f.icon size={20} />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-[#0A1B5E]">{f.title}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
